const initialState = {};

export default function dashboardSlice(state = initialState, action) {
  return state;
}
